<template>
  <div class="descriptionOfPack">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Workshop_Plant_Overview') }}
    </div>
    <div class="productProcess-list">
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Factory_Area') }}</span>
        <a-input v-model="data.overviewFactoryarea"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Office_Area') }}</span>
        <a-input v-model="data.overviewOfficearea"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Workshop_Area') }}</span>
        <a-input v-model="data.overviewWorkshoparea"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Raw_Material_Warehouse_Area') }}</span>
        <a-input v-model="data.overviewMaterialarea"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Products_Warehouse_Aera') }}</span>
        <a-input v-model="data.overviewProductsaera"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Showroom_Area') }}</span>
        <a-input v-model="data.overviewShowroomarea"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.Factory_Environment') }}</span>
        <a-radio-group name="radioGroup" v-model="data.overviewEnvironment">
          <a-radio value="1">{{ $tc('lang.factoryReport.Clean') }}</a-radio>
          <a-radio value="2">{{ $tc('lang.factoryReport.Dirty') }}</a-radio>
        </a-radio-group>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.factoryReport.remarks') }}：</span>
        <a-input v-model="data.overviewRemark"></a-input>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Gate') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportGate"
          :otherData="{
            mediaName: '工厂大门',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportGate',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Office') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportOffice"
          :otherData="{
            mediaName: '办公区域',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportOffice',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Showroom') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportShowroom"
          :otherData="{
            mediaName: '样品室',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportShowroom',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Workshop') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportWorkshop"
          :otherData="{
            mediaName: '生产车间',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportWorkshop',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Raw_Material_Warehouse') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportMaterialwarehouse"
          :otherData="{
            mediaName: '原料仓库',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportMaterialwarehouse',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.FG_Warehouse') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportFgwarehouse"
          :otherData="{
            mediaName: '成品仓库',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportFgwarehouse',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Staff_Dormitory') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportStaffdormitory"
          :otherData="{
            mediaName: '员工宿舍楼',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportStaffdormitory',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Canteen') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportCanteen"
          :otherData="{
            mediaName: '食堂',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportCanteen',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Factory_Infirmary') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.freportInfirmary"
          :otherData="{
            mediaName: '医务室',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportInfirmary',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      data: {},
      id: this.$route.query.id,
      aa: 1,
    };
  },
  components: {
    showImg,
  },
  computed: {
    factoryDetails: {
      get() {
        return this.$store.state.report.factoryDetails;
      },
      set(val) {
        this.$store.commit('report/save', { factoryDetails: val });
      },
    },
    descriptionOfPack: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.factoryImgList.descriptionOfPack,
          ),
        );
      },
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/factory-overview/seachFactoryOverview', {
          freportId: this.factoryDetails.freportId,
        })
        .then(data => {
          if (data.data) {
            this.data = data.data;
          } else {
            this.data = {};
          }
        })
        .catch(() => {
          this.data = {};
        });
    },
    handleSubmit() {
      this.$http
        .post('/hzwmj/factory-overview/saveOrUpdateFactoryOverview', {
          ...this.data,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getDetail();
            // this.details = data;
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      let fileList3 = [];
      let fileList4 = [];
      let fileList5 = [];
      let fileList6 = [];
      let fileList7 = [];
      let fileList8 = [];
      this.descriptionOfPack.freportGate.forEach(item => {
        fileList.push(item.id);
      });
      this.descriptionOfPack.freportOffice.forEach(item => {
        fileList1.push(item.id);
      });
      this.descriptionOfPack.freportShowroom.forEach(item => {
        fileList2.push(item.id);
      });
      this.descriptionOfPack.freportWorkshop.forEach(item => {
        fileList3.push(item.id);
      });
      this.descriptionOfPack.freportMaterialwarehouse.forEach(item => {
        fileList4.push(item.id);
      });
      this.descriptionOfPack.freportFgwarehouse.forEach(item => {
        fileList5.push(item.id);
      });
      this.descriptionOfPack.freportStaffdormitory.forEach(item => {
        fileList6.push(item.id);
      });
      this.descriptionOfPack.freportCanteen.forEach(item => {
        fileList7.push(item.id);
      });
      this.descriptionOfPack.freportInfirmary.forEach(item => {
        fileList8.push(item.id);
      });
      var postData = {
        freportId: this.factoryDetails.freportId,
        freportMedianame: '基本信息',
        freportMediatype: '1',
        modelType: '3',

        freportGate: fileList.join(','),
        freportOffice: fileList1.join(','),
        freportShowroom: fileList2.join(','),
        freportWorkshop: fileList3.join(','),
        freportMaterialwarehouse: fileList4.join(','),
        freportFgwarehouse: fileList5.join(','),
        freportStaffdormitory: fileList6.join(','),
        freportCanteen: fileList7.join(','),
        freportInfirmary: fileList8.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/factory-media/saveOrUpdateFactoryMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfactoryImg',
              this.factoryDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfPack {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
}
</style>
